import { EntityRepository, Repository } from "typeorm";
import { Soaking } from "./soaking.entity";

@EntityRepository(Soaking)
export class SoakingRepository extends Repository<Soaking> {
    
}